import { TipoSolicitud } from '../../../core/models/enum/tipo-solicitud.enum'; // Asegúrate de importar tu enum

export class TipoSolicitudHelper {

  // Mapeamos el Enum a su etiqueta legible
  private static readonly MAPA_TIPOS: Record<number, string> = {
    [TipoSolicitud.AFILIACION_TITULAR]: 'Afiliacion Titular',
    [TipoSolicitud.CAMBIO_ESTADO_CIVIL]: 'Cambio estado civil',
    [TipoSolicitud.RETIRO_BENEFICIARIO]: 'Retiro Beneficiario',
    [TipoSolicitud.RETIRO_TRABAJADOR]: 'Retiro Trabajador',
    [TipoSolicitud.AFILIACION_BENEFICIARIO]: 'Afiliación Beneficiario',
    [TipoSolicitud.SOLICITUD_DISCAPACIDAD]: 'Solicitud discapacidad',
    [TipoSolicitud.ACM]: 'ACM',
    [TipoSolicitud.NOVEDAD_CUOTA_MONETARIA]: 'Novedad Cuota Monetaria',
    [TipoSolicitud.NOVEDAD_DISCAPACIDAD]: 'Novedad Discapacidad',
  };

  /**
   * Convierte el ID numérico en texto legible.
   */
  public static obtenerNombreTipo(codigo: number | string | null | undefined): string {
    if (codigo === null || codigo === undefined || codigo === '') {
      return 'Sin tipo';
    }
    let num: number;
    if (isNaN(Number(codigo))) {
      num = TipoSolicitud[codigo as keyof typeof TipoSolicitud];
    } else {
      num = Number(codigo);
    }
    return this.MAPA_TIPOS[num] || codigo.toString();
  }

  public static obtenerOpcionesFiltro() {
    return Object.keys(TipoSolicitud)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        valor: TipoSolicitud[key as keyof typeof TipoSolicitud],
        nombre: this.MAPA_TIPOS[TipoSolicitud[key as keyof typeof TipoSolicitud]] || key
      }));
  }

  public static obtenerIdPorNombreLegible(valor: string | number | null | undefined): number | undefined {

    if (valor === null || valor === undefined) return undefined;
    if (typeof valor === 'number') return valor;
    const valorNumerico = Number(valor);
    if (!isNaN(valorNumerico) && String(valor).trim() !== "") {
      return valorNumerico;
    }
    const nombreBusqueda = String(valor).toLowerCase().trim();
    const entrada = Object.entries(this.MAPA_TIPOS).find(([id, texto]) =>
      texto.toLowerCase().trim() === nombreBusqueda
    );

    return entrada ? Number(entrada[0]) : undefined;
  }
}